export default navigator.language || navigator.userLanguage || 'en-US'
